import { DataAttributeDefinitions } from 'scrivito'

import { pisaTimerecordOrderDataClass } from './Pisa/pisaTimerecordOrderDataClass'

const attributes: DataAttributeDefinitions = {}

export const TimerecordOrder = pisaTimerecordOrderDataClass(attributes)
